import React from "react";
import { getCompanyProfiles } from "shared/utils/companyUtils";
import { CompanyProfile } from "shared/utils/fieldsHelper/companyFields";

interface Props {
  profile: CompanyProfile
}

const ProfileRow = ({ profile }: Props) => {
  const profiles = getCompanyProfiles(profile, site.currentEnvironment.functionGroups, RESX.Artist.NoLongerActive);

  if (profiles.length === 0) {
    return <></>;
  }

  return <div>
    {profiles.join(", ")}
  </div>
};

export default ProfileRow;
